import React from 'react';
import { useFormikContext, getIn } from 'formik';
import AsyncSelect from 'react-select/async'; 
const Selector = ({ id, ...rest }) => {
    const { touched, errors } = useFormikContext();
    const invalid = getIn(errors, id) && getIn(touched, id);
    const style = invalid ? { borderColor: 'red' } : null
    return <AsyncSelect id={id} styles={{
        control: provided => ({ ...provided, ...style }),
        // Fixes the overlapping problem of the component
        menu: provided => ({ ...provided, zIndex: 9999 })
    }} {...rest} />
}
export default Selector